import { render, staticRenderFns } from "./DMIContactModal.vue?vue&type=template&id=2d16e286&scoped=true&"
import script from "./DMIContactModal.vue?vue&type=script&lang=js&"
export * from "./DMIContactModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d16e286",
  null
  
)

export default component.exports